export const auHref = "https://fantuan.com.au/delivery"
export const caHref = "https://fantuan.ca/delivery"
export const webHref = (lang) =>{
  return `https://app.adjust.com/gx6pe61?redirect=https%3A%2F%2Fwww.fantuanorder.com%2F${lang}%3Futm_source%3Dofficialwebsite%26utm_medium%3Dreferral%26utm_campaign%3Dofficial_website`
}
// export const webHref =
// "https://app.adjust.com/gx6pe61?redirect=https%3A%2F%2Fwww.fantuanorder.com%2F%3Futm_source%3Dofficialwebsite%26utm_medium%3Dreferral%26utm_campaign%3Dofficial_website"

export const phoneList = {
  ca: {
    zh: [
      {
        city: "温哥华",
        phone: "+1-7788963349",
      },
    ],
    en: [
      {
        city: "Vancouver",
        phone: "+1-7788963349",
      },
    ],
    fr: [
      {
        city: "Vancouver",
        phone: "+1-7788963349",
      },
    ],
  },
  us: {
    zh: [
      {
        city: "曼哈顿",
        phone: "+1 (347) 438-9836",
      },
    ],
    en: [
      {
        city: "Manhattan",
        phone: "+1 (347) 438-9836",
      },
    ],
    fr: [
      {
        city: "Manhattan",
        phone: "+1 (347) 438-9836",
      },
    ],
  },
  au: {
    zh: [],
    en: [],
    fr: [],
  },
}

export const languageMap = {
  en: "en-US",
  zh: 'zh-CN',
  fr: 'fr-FR'
}